import { Badge } from '@ibsys/kit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CONVERSATION_PHRASE_PARAM, useConversationLink } from '@/entities/conversations';
import type { StrategistCellReply } from '@/entities/strategist';

type Props = {
  /** Диалог реплики */
  conversationId: number;
  reply: StrategistCellReply;
};

/**
 * Реплика среза: кто говорит и дословный текст. Переход открывает диалог на самой реплике,
 * а когда её положение неизвестно — сам диалог. Возврат ведёт обратно в раздел по общему
 * контракту возврата ({@link useConversationLink}).
 */
export const ReplyRow: FC<Props> = ({ conversationId, reply }) => {
  const { t } = useTranslation('strategist');
  const buildLink = useConversationLink();
  const isEmployee = reply.speaker === 'E';
  const { to, state } = buildLink(
    conversationId,
    reply.phraseId != null ? { [CONVERSATION_PHRASE_PARAM]: String(reply.phraseId) } : undefined,
  );

  return (
    <Link
      to={to}
      state={state}
      className="flex cursor-pointer flex-col gap-1.5 rounded-xl border border-border bg-card p-3 transition-colors hover:bg-accent"
    >
      <Badge variant={isEmployee ? 'primary' : 'secondary'} outline>
        {isEmployee ? t('dialogsDrawer.speaker.employee') : t('dialogsDrawer.speaker.client')}
      </Badge>
      <span className="line-clamp-3 text-sm text-foreground whitespace-pre-wrap">{reply.text}</span>
    </Link>
  );
};
